module.exports = __webpack_public_path__ + "static/media/wallet.590fdd90.svg";